import { SubscriptionWarning } from "src/app/app.types";
import { createNumericalCompare } from "./array-helpers";

export const usageThresholdMap: Record<number, SubscriptionWarning> = {
    0: "none",
    90: "high",
    100: "severe"
  };

 export const getUsageThreshold = (limit: number, used: number): SubscriptionWarning => {
    if(limit < 0)
      {return "none";}

    const percentUsed = (used/limit)*100;

    const thresholdNumbers = Object.keys(usageThresholdMap).map(Number);

    let threshold = thresholdNumbers.find(x => x === percentUsed);

    if(!threshold){
      thresholdNumbers.push(percentUsed);
      const compareNumbers = createNumericalCompare((a: number) => a)
      thresholdNumbers.sort(compareNumbers);
      
      const previousIndex = thresholdNumbers.indexOf(percentUsed) - 1;
      threshold = thresholdNumbers[previousIndex];
    }

    return usageThresholdMap[threshold];
  }